<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { getTourmkrUrl } from '~/utils/tourmkr';

const props = withDefaults(defineProps<{
  url?: string | null;
  title?: string | null;
}>(), {
  url: null,
  title: 'BVGCI virtual tour',
});

const src = computed(() => getTourmkrUrl(props.url));
const isLoading = ref(true);
watch(src, () => { isLoading.value = true; });
</script>

<template>
  <div v-if="src" class="space-y-3">
    <div class="relative overflow-hidden rounded-panel border border-neutral-300 bg-neutral-100 dark:border-neutral-700 dark:bg-neutral-900">
      <p v-if="isLoading" role="status" class="absolute inset-x-0 top-4 z-10 text-center text-sm text-neutral-700 dark:text-neutral-200 pointer-events-none">
        Loading virtual tour…
      </p>
      <iframe
        :key="src"
        :src="src"
        :title="title || 'BVGCI virtual tour'"
        class="tourmkr-frame relative block w-full border-0"
        allow="autoplay; fullscreen; gyroscope; accelerometer"
        allowfullscreen
        referrerpolicy="strict-origin-when-cross-origin"
        @load="isLoading = false"
      />
    </div>
    <p class="text-sm text-neutral-700 dark:text-neutral-200">
      Use the tour menu to explore our projects.
      <a :href="src" target="_blank" rel="noopener noreferrer" class="underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-4">
        Open the tour in a new tab
      </a>
    </p>
  </div>
  <p v-else role="status" class="py-12 text-center">The virtual tour is currently unavailable.</p>
</template>

<style scoped>
.tourmkr-frame {
  height: clamp(420px, 75svh, 900px);
}

@media (max-height: 500px) and (orientation: landscape) {
  .tourmkr-frame {
    height: 85svh;
    min-height: 280px;
  }
}
</style>
